import { render } from "./interfaceComponent.vue?vue&type=template&id=80b90bac&scoped=true"
import script from "./interfaceComponent.vue?vue&type=script&lang=js"
export * from "./interfaceComponent.vue?vue&type=script&lang=js"

import "./interfaceComponent.vue?vue&type=style&index=0&id=80b90bac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b90bac"]])

export default __exports__